"use client";
import { UnloggedUserLayout } from "@/shared/Layout/UnloggedUserLayout";
import { isChunkLoadError, reloadForChunkError } from "@/shared/chunk-reload";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useEffect } from "react";

export default function ErrorPage({ error, reset }: { error: Error; reset: () => void }) {
  useEffect(() => {
    if (isChunkLoadError(error)) {
      reloadForChunkError();
    }
  }, [error]);

  return (
    <UnloggedUserLayout>
      <Stack sx={{ alignItems: "center", bgcolor: "background.default", color: "text.primary", px: 2 }}>
        <Typography variant="sectionTitle" gutterBottom>
          Something went wrong
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Typography variant="bodyMuted">{error?.message || "An unexpected error has occurred."}</Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" color="primary" onClick={() => reset()}>
            Try Again
          </Button>
        </Box>
      </Stack>
    </UnloggedUserLayout>
  );
}
